"use client";

import { LOGO_DARK, LOGO_LIGHT } from "@constants/global";
import ToggleTheme from "components/ToggleTheme/ToggleTheme";
import { useTheme } from "next-themes";
import useTranslation from "next-translate/useTranslation";
import Image from "next/image";

/** Navbar para rutas públicas (perfil público, portal, etc.). */
export default function PublicNavbar() {
  const { theme } = useTheme();
  const { t } = useTranslation("common");

  return (
    <>
      {/* Barra de color superior */}
      <div className="h-1 min-h-[4px] w-full bg-gradient-to-r from-blue-600 to-blue-800" />

      {/* Navbar */}
      <nav className="sticky top-0 w-full items-center justify-between border-b border-gray-200 bg-gray-50 pr-4 shadow-[0_4px_12px_rgba(15,23,42,0.12),0_1px_3px_rgba(15,23,42,0.08)] dark:border-gray-600 dark:bg-gray-900 dark:shadow-[0_4px_12px_rgba(0,0,0,0.3),0_1px_3px_rgba(0,0,0,0.2)]">
        <div className="flex items-center justify-items-stretch">
          <div className="grid h-[79px] w-full items-center pl-4">
            <Image
              src={theme === "dark" ? LOGO_DARK : LOGO_LIGHT}
              width={180}
              height={60}
              alt="Logo"
              className="h-auto max-w-[154px]"
              priority
            />
          </div>
          <div className="flex w-full gap-2">
            <div className="grid w-full items-center justify-end py-1 text-center text-sm font-semibold text-slate-500 dark:text-white">
              {t("PROFILE_FOOTER")}
            </div>
            <ToggleTheme />
          </div>
        </div>
      </nav>
    </>
  );
}
